import { LinkExpirationMeaning } from 'phoenix/domain';
import * as moment from 'moment';

type RelativeDateMeaning = LinkExpirationMeaning.Days | LinkExpirationMeaning.Hours | LinkExpirationMeaning.Minutes;

export class DateService {
	public readonly maxDate = new Date(Date.UTC(9999,11,31,23,59,59,997));

	constructor() {
	}

	public getRelativeDate(meaning:RelativeDateMeaning, durationAmount:number, referenceDate:Date = new Date()) {
		let relativeDate:Date;

		switch(meaning) {
			case LinkExpirationMeaning.Days:
				relativeDate = moment(referenceDate).add(durationAmount, 'days').toDate();
				break;
			case LinkExpirationMeaning.Hours:
				relativeDate = moment(referenceDate).add(durationAmount, 'hours').toDate();
				break;
			case LinkExpirationMeaning.Minutes:
				relativeDate = moment(referenceDate).add(durationAmount, 'minutes').toDate();
				break;
			default:
				throw new Error('Unsupported relative date meaning');
		}

		return relativeDate;
	}
}


// WEBPACK FOOTER //
// ./src/phoenix/services/date-service.ts